import {
  AcademicEnrollmentType,
  ProfileValueOptionResponse,
  UserProfileResponse,
} from '@backrs_ui/grow-ui/src/redux/profile/profile';

/**
 *
 * This function will filter out any values you do not want to appear in the profile edit page.
 */
export const filterEditProfileProfileOptions = (
  profileOptions: ProfileValueOptionResponse | undefined,
): ProfileValueOptionResponse | undefined => {
  if (!profileOptions) return undefined;

  // Create a new object with the same structure
  const filteredOptions: ProfileValueOptionResponse = {
    ...profileOptions,
    // Filter academicEnrollmentTypes to only include IDs 2, 3, 4, 5
    academicEnrollmentTypes: profileOptions.academicEnrollmentTypes.filter((option) => {
      const allowedIds = [1, 2, 3, 4, 5, 6];

      return allowedIds.includes(option.id);
    }),
  };

  return filteredOptions;
};

export const getEnrollmentIds = (
  options: ProfileValueOptionResponse | undefined,
  desiredLevel: AcademicEnrollmentType,
) => {
  if (!options) return [];

  return options.academicEnrollmentTypes
    .filter((opt) => opt.level === desiredLevel)
    .map((opt) => opt.id);
};

export const isCurrentlyInEduLevel = (
  eduLevel: AcademicEnrollmentType,
  profile?: UserProfileResponse,
  options?: ProfileValueOptionResponse,
) => {
  if (!profile?.profile?.academicEnrollmentTypes || !options) return false;

  const eduLevelIds = getEnrollmentIds(options, eduLevel);

  return eduLevelIds.includes(profile.profile.academicEnrollmentTypes);
};

const HOW_MANY_YEARS_TO_SHOW_FORMER_SCHOOL_YEARS = 51; // 50 + 1 for current year
const HOW_MANY_YEARS_TO_SHOW_FUTURE_SCHOOL_YEARS = 10;

export const getGraduationYears = (
  eduLevel: AcademicEnrollmentType,
  profile?: UserProfileResponse,
  options?: ProfileValueOptionResponse,
) => {
  const currentYear = new Date().getFullYear();

  const isInEduLevel = isCurrentlyInEduLevel(eduLevel, profile, options);

  const arrayLength = isInEduLevel
    ? HOW_MANY_YEARS_TO_SHOW_FUTURE_SCHOOL_YEARS
    : HOW_MANY_YEARS_TO_SHOW_FORMER_SCHOOL_YEARS;

  // we will either get the next 10 or last 50 years
  const years = Array.from({ length: arrayLength }, (_, index) => {
    if (isInEduLevel) {
      return currentYear + index;
    }

    return currentYear - index;
  });

  return years.map((year) => ({
    id: year,
    name: year.toString(),
    value: year.toString(),
  }));
};
